import Icon from "~/components/shared/Icon";
import { State, WaitStep } from "~/lib/pipeline";
import { WAIT_STEP_HEIGHT } from "~/components/build/Show/pages/steps/list/components/constants";
import { TreeNode } from "~/components/build/Show/pages/steps/list/components/TreeNode";

interface Props {
  step: WaitStep;
}

export function WaitStepItem({ step }: Props) {
  return (
    <div className="flex h-full w-full items-center px-1.5">
      <div className="flex flex-1 items-center gap-2">
        <div className="flex-1 border-b border-gray-400" />
        <Icon
          icon={
            step.state === State.Finished
              ? "heroicons/outline/chevron-down"
              : "heroicons/solid/pause"
          }
          className="text-charcoal-300 h-3 w-3 shrink-0"
        />
        <div className="flex-1 border-b border-gray-400" />
      </div>
    </div>
  );
}

export const createWaitStepNode = (step: WaitStep): TreeNode => ({
  id: step.uuid,
  height: WAIT_STEP_HEIGHT,
  render: () => <WaitStepItem step={step} />,
});
